// src/components/common/ProductStatusDot.tsx
import React from 'react';
import { Tooltip } from 'antd';

type ProductItem = {
  img?: string;
  images?: any[];
  references?: Record<string, string[]>;
  oems?: Record<string, string[]>;
};

function hasImage(item: ProductItem): boolean {
  if (item.img) return true;
  if (Array.isArray(item.images) && item.images.length > 0) return true;
  return false;
}

function hasRefs(item: ProductItem): boolean {
  return !!(item.references && Object.keys(item.references).length > 0);
}

function hasOems(item: ProductItem): boolean {
  return !!(item.oems && Object.keys(item.oems).length > 0);
}

const DOT: React.CSSProperties = {
  display: 'inline-block',
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};

interface Props {
  item: ProductItem;
}

const ProductStatusDot: React.FC<Props> = ({ item }) => {
  const imgOk   = hasImage(item);
  const refsOk  = hasRefs(item);
  const oemsOk  = hasOems(item);

  const imgColor  = imgOk ? '#52c41a' : '#722ed1';
  const dataColor = (refsOk && oemsOk) ? '#52c41a' : '#faad14';

  const imgTip  = imgOk  ? 'Фото есть' : 'Фото отсутствует';
  const dataTip = (refsOk && oemsOk)
    ? 'Реф и OEM номера есть'
    : !refsOk && !oemsOk
    ? 'Реф и OEM номера отсутствуют'
    : !refsOk
    ? 'Реф номера отсутствуют'
    : 'OEM номера отсутствуют';

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, marginRight: 6 }}>
      <Tooltip title={imgTip}>
        <span style={{ ...DOT, background: imgColor }} />
      </Tooltip>
      <Tooltip title={dataTip}>
        <span style={{ ...DOT, background: dataColor }} />
      </Tooltip>
    </span>
  );
};

export default ProductStatusDot;
